<template>

  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div>

  <!-- <div class="flex" id="signin">
    <div id="signin_cover">
      <div><a href="/">Logo</a></div>
    </div>

    <div id="signin_form">
      <div id="signin_form_inner">

        <div id="app_main">
          <router-view></router-view>
        </div>

      </div>
    </div>
  </div> -->

</template>

<script>
//https://github.com/cornflourblue/vue-facebook-login-example/tree/master/src

import { authService } from "@/services/auth";

const default_layout = "default";

export default {

  name: "App",

  metaInfo () { 
    return { 
      htmlAttrs: {
        lang: window.locale
      },
     } 
  },
  
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    }
  },
  updated() {
    // something defined here whatever the this.$route.path
    // console.log(this.$route, this.$route.meta.layout);
  },

  // created() {
  //   // nothing defined here (when this.$route.path is other than "/")
  //   console.log(this.$route, this.$route.meta.layout);
  // },
  async created() {

    try {
      // console.log(this.$route, this.$route.meta.layout);

      // store adcash clickid
      if (this.$route.query.clickid) {
        this.$cookies.set("cid", this.$route.query.clickid);
      }
      
      // const unauthRoutes = ["/register"];

      // // if (unauthRoutes.indexOf(this.$router.currentRoute.path.toLowerCase()) == -1) {

      // let userIsconnected_Pool = await authService.isConnectedWithUserPool();
      // let userIsconnected_Social = await authService.isConnectedWithSocial();
      
      // if (userIsconnected_Pool || userIsconnected_Social) {
      //   window.location.href = process.env.VUE_APP_APP_URL;
      // }
      // else this.$router.push("/register");

      // // let user = authService.awsGetConnectedUser();
      // // if (user != null) window.location.href = process.env.VUE_APP_APP_URL;
      // // else this.$router.push("/register");

      // // }
    } catch (error) {
      console.log(error)
      // this.$router.push("/register");
    }
  },
};


</script>